import { storage } from '../utils/storage';

const WS_URL = process.env.REACT_APP_WS_URL || 'ws://localhost:3002';
const isDev = process.env.NODE_ENV === 'development';

class WebSocketService {
  constructor() {
    this.ws = null;
    this.listeners = {};
    this.restaurantId = null;
    this.reconnectTimeout = null;
    this.shouldReconnect = true;
  }

  connect(restaurantId = null) {
    // Si no se proporciona restaurantId, intentar obtenerlo del localStorage
    if (!restaurantId) {
      restaurantId = storage.get('selectedRestaurantId');
    }

    // Si aún no hay restaurantId, no conectar
    if (!restaurantId) {
      if (isDev) {
        console.warn('No se puede conectar WebSocket: no hay restaurantId seleccionado');
      }
      return;
    }

    // Si ya estamos conectados al mismo restaurante, no reconectar
    if (this.ws && this.ws.readyState === WebSocket.OPEN && this.restaurantId === restaurantId) {
      if (isDev) {
        console.log('WebSocket ya conectado al restaurante:', restaurantId);
      }
      return;
    }

    // Si estamos conectados a un restaurante diferente, desconectar primero
    if (this.ws && this.restaurantId !== restaurantId) {
      if (isDev) {
        console.log('Cambiando conexión de restaurante:', this.restaurantId, '→', restaurantId);
      }
      this.shouldReconnect = false;
      this.disconnect();
      this.shouldReconnect = true;
    }

    this.restaurantId = restaurantId;
    const url = `${WS_URL}?restaurantId=${restaurantId}&clientType=comanda`;

    try {
      if (isDev) {
        console.log('Conectando WebSocket a:', url);
      }
      this.ws = new WebSocket(url);
    } catch (err) {
      if (isDev) {
        console.error('WebSocket connection failed:', err.message);
      }
      this.scheduleReconnect();
      return;
    }

    this.ws.onopen = () => {
      if (isDev) {
        console.log('WebSocket conectado al restaurante:', restaurantId);
      }
      if (this.reconnectTimeout) {
        clearTimeout(this.reconnectTimeout);
        this.reconnectTimeout = null;
      }
    };

    this.ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (isDev) {
          console.log('Mensaje recibido:', data);
        }
        this.emit(data.type, data);
      } catch (err) {
        if (isDev) {
          console.error('WebSocket message parse error:', err.message);
        }
      }
    };

    this.ws.onerror = () => {
      const state = this.ws ? this.ws.readyState : 'no-socket';
      console.warn(
        `WebSocket error — url: ${url}, readyState: ${state}, reconnect: ${this.shouldReconnect}`
      );
    };

    this.ws.onclose = () => {
      if (isDev) {
        console.log('WebSocket desconectado');
      }
      this.scheduleReconnect();
    };
  }

  scheduleReconnect() {
    if (this.shouldReconnect && this.restaurantId) {
      if (isDev) {
        console.log('Reconectando en 5s...');
      }
      this.reconnectTimeout = setTimeout(() => {
        this.connect(this.restaurantId);
      }, 5000);
    }
  }

  on(event, callback) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);
  }

  off(event, callback) {
    if (this.listeners[event]) {
      this.listeners[event] = this.listeners[event].filter(cb => cb !== callback);
    }
  }

  emit(event, data) {
    if (this.listeners[event]) {
      this.listeners[event].forEach(callback => callback(data));
    }
  }

  disconnect() {
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
  }
}

const websocketService = new WebSocketService();
export default websocketService;
